<script setup lang="ts">
import type { NovaBoxFundHistoryItemProps } from './NovaBoxFundHistoryItem.types'

defineProps<NovaBoxFundHistoryItemProps>()

const { t } = useI18n()
</script>

<template>
  <a class="history-item">
    <div class="profile-area">
      <NovaImageContainer
        :ratio="'1:1'"
        :image-url="source.proflFileUrl"
        :empty-type="'portrait'"
      />
    </div>

    <div class="info-area">
      <div class="upper">
        <span class="no">
          {{ t('fund.histories.fundNo', { fundNo: source.crfdSuptCycleOdr }) }}
        </span>
        <span class="name">
          {{
            t('fund.histories.creatorNickname', {
              creatorNickname: source.crtrNcnm,
            })
          }}
        </span>
      </div>

      <div class="lower">
        <p class="title">
          {{
            useFindLocaleByNamespace({
              nameSpace: 'prjctSjNm',
              model: source,
            })
          }}
        </p>
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
.history-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  padding: 20px 15px 17px;
  background-color: $color-white;
  box-shadow: 0 0 12px 0 #0000001a;
  cursor: pointer;

  .info-area {
    display: flex;
    flex-direction: column;

    .upper {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      font-size: 15px;
      text-align: center;
      line-height: 1.29;
      color: $color-black;

      > .date {
        flex-shrink: 0;
      }

      > .name {
        @include ellipsis(1);
      }
    }

    .lower {
      .title {
        font-size: 20px;
        text-align: center;
        line-height: 1.29;
        color: $color-black;
        @include ellipsis(2);
      }
    }
  }

  @include mobile {
    padding: 17px 12px;

    .info-area {
      .upper {
        font-size: 12px;
      }

      .lower {
        .title {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
